module.exports = __webpack_public_path__ + "img/learning-1.090ea18e.png";